import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Content, Button, Label } from './plate.styled';

export const Plate = (props) => {
  const { t } = useTranslation();
  const { value, change, loading, title, disabled, id } = props;
  const [plate, setPlate] = useState(value);

  useEffect(() => {
    // console.log('🚀 ~ Plate ~ id:', id);
    setPlate(value);
  }, [id]);

  const onChange = () => {
    if (!plate) {
      return;
    }
    change(plate);
  };

  const changePlate = (e) => {
    const val = e.target.value;
    setPlate(val);
  };

  const cl = loading ? 'loading' : '';
  const titleOk = title ?? t('means.ГРЗ');

  return (
    <Content className={cl}>
      <Label>
        {titleOk}&nbsp;:
      </Label>
      <input disabled={disabled} type="text" value={plate} onChange={changePlate} />
      <Button type="button" onClick={onChange}>
        {t('buttons.Установить')}
      </Button>
    </Content>
  );
};
